export const CompViewFilter = {
    SIZE: "size",
    GEO_BOX_FILTER: "geo_box_filter",
}
